import { Outlet } from 'react-router-dom';
import { OrganizerSidebar } from './OrganizerSidebar';
import { useUIStore } from '@/store/uiStore';
import { cn } from '@/utils/cn';

const OrganizerHeader = () => {
  const { toggleSidebar } = useUIStore();

  return (
    <header className="sticky top-0 z-40 flex h-16 items-center gap-4 border-b border-gray-200 bg-white px-6 shadow-sm">
      <button
        onClick={toggleSidebar}
        className="rounded-md p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
        aria-label="Toggle sidebar"
      >
        <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <div className="flex-1">
        <h1 className="text-base font-semibold text-gray-900">
          Turniej Przetwórstwo Mleczarskie
        </h1>
      </div>

      <div className="flex items-center gap-3">
        <span className="hidden text-sm text-gray-400 sm:block">Panel Organizatora</span>
      </div>
    </header>
  );
};

export const OrganizerLayout = () => {
  const { sidebarOpen } = useUIStore();

  return (
    <div className="min-h-screen bg-competition-bg">
      <OrganizerSidebar />
      <div className={cn('flex flex-col transition-all duration-300', sidebarOpen ? 'pl-64' : 'pl-16')}>
        <OrganizerHeader />
        <main className="flex-1 p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
